module.exports = __webpack_public_path__ + "static/img/swiper_03.ed5486d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/refluxCustomer/swiper_03.png
// module id = Wif3
// module chunks = 1